import styled from 'styled-components';

import {
    subMenuDropdownBackground
} from '../../config/colors';

export const ViewsAndLayoutsWrapper = styled.ul`
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    height: 100%;
    margin: 0;
    padding: 50px 110px 35px 110px;
    background-color: ${subMenuDropdownBackground};
    
    @media print {
        background-color: inherit;
        padding: 0px;
        break-before: always;
        break-after: always;
    }
`;
